/**
 * Yields to the main thread with timing optimized for immediate visual feedback.
 *
 * Use this when users need instant acknowledgment of their interaction.
 * The browser gets time to paint UI changes (like loading states) before
 * continuing with heavy processing.
 *
 * @returns A Promise that resolves after the browser has had a chance to paint
 *
 * @example
 * ```ts
 * const handleSubmit = async () => {
 *   setStatus('submitting');
 *   await interactionResponse();
 *
 *   // Heavy work happens after browser has painted "submitting" state
 *   await validateAndSubmit();
 *   setStatus('done');
 * };
 * ```
 */
export const interactionResponse = (): Promise<void> => {
  return new Promise((resolve) => {
    // Fallback for the case where the animation frame never fires
    setTimeout(resolve, 100);
    requestAnimationFrame(() => {
      setTimeout(resolve, 0);
    });
  });
};
